module.exports = __webpack_public_path__ + "img/stock.78da3d6a.jpg";